var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"admin-client-features"}},[_c('div',{staticClass:"data-header"},[_vm._m(0),_c('div',{staticClass:"data-header-actions"},[_vm._v(" "+_vm._s(_vm.users)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-header-tabs"},[_c('span',{staticClass:"data-header-tabs-tab active"},[_vm._v("Users")])])
}]

export { render, staticRenderFns }